import React from "react";

import { Tooltip } from "@material-ui/core";
import { green, orange, red } from "@material-ui/core/colors";

import {
  AdviceCompletedIcon,
  AdviceErrorIcon,
  AdviceProcessingIcon,
  RejectIcon,
  RemoveIcon,
} from "../../../components/common/iconography";
import { InboundStatus } from "../../../utils/constants";

// Status icon for the customer Inbound "Advices" tab. Mirrors the outbound
// AdviceStatusIcon but covers the full inbound advice lifecycle:
// ADVICE_PROCESSING -> ADVICE_REVIEW (or ADVICE_FAILED) -> ADVICE_REJECTED.
export const AdviceStatusIcon = ({ record }) => {
  if (!record) return null;

  switch (record.status) {
    case InboundStatus.ADVICE_PROCESSING:
      return (
        <Tooltip title="Processing" placement="right" arrow>
          <AdviceProcessingIcon style={{ color: orange[600] }} />
        </Tooltip>
      );
    case InboundStatus.ADVICE_REVIEW:
      return (
        <Tooltip title="Pending Review" placement="right" arrow>
          <AdviceCompletedIcon style={{ color: green[600] }} />
        </Tooltip>
      );
    case InboundStatus.ADVICE_FAILED:
      return (
        <Tooltip title="Processing Failed" placement="right" arrow>
          <AdviceErrorIcon style={{ color: red[600] }} />
        </Tooltip>
      );
    case InboundStatus.ADVICE_REJECTED:
      return (
        <Tooltip title="Rejected" placement="right" arrow>
          <RejectIcon style={{ color: red[700] }} />
        </Tooltip>
      );
    default:
      return (
        <Tooltip title="Advice" placement="right" arrow>
          <RemoveIcon color="disabled" />
        </Tooltip>
      );
  }
};
